import { render, staticRenderFns } from "./AvaliacaoAcademy.vue?vue&type=template&id=361e60e9&scoped=true&"
import script from "./AvaliacaoAcademy.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoAcademy.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoAcademy.vue?vue&type=style&index=0&id=361e60e9&scoped=true&lang=css&"
import style1 from "./AvaliacaoAcademy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e60e9",
  null
  
)

export default component.exports